

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Series, SeriesSearchRequest, PagedResult } from '@shared/models';
	import ProItem from '@client/views/industry/pros/ProItem.vue';

	@Component({
		components: {
			ProItem,
		},
	})
	export default class CompanySeries extends BaseView {

		public modelId: string = '';
		public list: PagedResult<Series> = new PagedResult<Series>();
		public criteria: SeriesSearchRequest = new SeriesSearchRequest({ pageIndex: 0, pageSize: 32, sortBy: 'year', sortDirection: 'asc' });

		public async mounted() {
			await this.refresh();
		}

		public async refresh() {
			this.loading = true;
			try {
				this.modelId = this.$route.params.id;
				this.criteria.companyIds.push(this.modelId);
				this.list = await this.$api.seriesService.search(this.criteria);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this companies series list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			this.refresh();
		}


	}

